import clsx from 'clsx';
import { HTMLAttributes, ReactNode } from 'react';
import MobileAppbar, {
  MobileAppbarProps,
} from '@/components/modules/MobileAppbar';

// components
import Appbar from '@/components/modules/Appbar';
import HelpBar from '@/components/modules/HelpBar';
import { useSidebar } from '@/store';
import Hidden from '@/components/elements/Hidden';
import Sidebar from '@/components/modules/Sidebar';
import Button from '@/components/elements/Button';
import SidebarBottomNavigation from '@/components/modules/SidebarBottomNavigation';

// eslint-disable-next-line @typescript-eslint/ban-types
export type DefaultTemplateProps = {
  children?: ReactNode;
  disableAppbar?: boolean;
  displayHelpBar?: boolean;
  page?: string;
  mobileAppbarProps?: MobileAppbarProps;
} & HTMLAttributes<HTMLElement>;

/**
 * @component DefaultTemplate
 */
// eslint-disable-next-line no-empty-pattern
function DefaultTemplate({
  className,
  children,
  disableAppbar,
  displayHelpBar,
  page,
  mobileAppbarProps,
}: DefaultTemplateProps) {
  const { collapse } = useSidebar();

  const rootClasses = clsx(`w-full h-screen flex`);
  const containerClasses = clsx(
    `default-template transition-all flex-1 flex flex-col`,
    { '!pr-0': displayHelpBar, '!pl-0 md:!pl-[85px] ': collapse },
  );
  const contentWrapperClasses = clsx(
    `flex-1 mt-[85px] md:mt-0 w-full mx-auto pb-24 max-w-full md:max-w-[1024px] lg:max-w-[1024px] xl:max-w-[1280px] 2xl:max-w-[1536px]`,
    {
      'md:p-8': disableAppbar,
      'md:p-8 !pt-0': !disableAppbar,
    },
    className,
  );
  return (
    <div className={rootClasses}>
      <Sidebar />

      <Hidden in="Mobile" not>
        <SidebarBottomNavigation />
      </Hidden>
      <div className={containerClasses}>
        <Hidden in="Mobile">{!disableAppbar && <Appbar />}</Hidden>
        <Hidden in="Mobile" not>
          {!disableAppbar && (
            <MobileAppbar
              page={page}
              {...mobileAppbarProps}
              renderRightButton={
                mobileAppbarProps?.renderRightButton
                  ? mobileAppbarProps.renderRightButton
                  : !displayHelpBar && (
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className="whitespace-nowrap flex-shrink-0 ml-3"
                      >
                        Need Help?
                      </Button>
                    )
              }
            />
          )}
        </Hidden>

        <div className={contentWrapperClasses}>{children}</div>
      </div>
      {!displayHelpBar && <HelpBar />}
    </div>
  );
}

export default DefaultTemplate;
